import React from "react";
import { useNavigate } from "react-router";
import csmGrayTextLogin from "../../assets/images/csmGrayTextLogin.png";

export default function ThankYou() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0fdf4",
        padding: "20px",
      }}
    >
      <img
        src={csmGrayTextLogin}
        alt="ProTeams Logo"
        style={{
          height: "80px",
          marginBottom: "30px",
        }}
      />
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "40px 30px",
          boxShadow: "0 4px 15px rgba(0, 128, 0, 0.2)",
          textAlign: "center",
          maxWidth: "500px",
          width: "100%",
        }}
      >

        <h2
          style={{
            color: "#065f46",
            marginBottom: "16px",
            fontSize: "20px",
            fontWeight: "500",
          }}
        >
          Thank You
        </h2>

        <p
          style={{
            color: "#065f46",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "22px",
            marginBottom: "12px",
          }}
        >
          You&apos;re all set — welcome to ProTeams.
        </p>

        <p
          style={{
            color: "#065f46",
            fontSize: "16px",
            lineHeight: "22px",
            marginBottom: "12px",
          }}
        >
          Your email is confirmed. We sent a few messages to your inbox: welcome details,
          account ready, and <strong>Set your password</strong>.
        </p>

        <p
          style={{
            color: "#065f46",
            fontSize: "15px",
            lineHeight: "22px",
            marginBottom: "24px",
          }}
        >
          Open <strong>Set your password</strong> first, save your password on the secure setup page,
          then return here to sign in. That link is valid for 24 hours.
        </p>

        <button
          type="button"
          onClick={() => navigate("/login")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#16a34a",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "15px",
            width: "100%",
            maxWidth: "320px",
          }}
        >
          Log in to your ProTeams dashboard
        </button>
      </div>
    </div>
  );
}
